import axios from "axios";

/**
     * 
     * @param {string} path
     * @param {string} method
     * @param {object} data
     * @returns {Promise}
     */
async function request(path, method, data) {
    // const url = "http://api.payment.local";
    const url = "https://acc.napagroup.ir/api";
    const trimPattern = /^\/+|\/+$/gm;
    const config = {
        url: url + "/" + String(path).replace(trimPattern, ""),
        method: method,
    };
    const token = sessionStorage.getItem('auth-token');

    if(String(method).toLowerCase() === 'get') {
        config.params = data;
    } else {
        config.data = data;
    }

    if(token) {
        config.headers = {
            Authorization: `Bearer ${token}`
        };
    }

    try {
        const response = await axios.request(config);

        return response;
    } catch (error) {
        switch(error.status) {
            case 401:
                redirectToLogin();
                break;
            case 403:
                redirectToForbidden();
                break;                
        }
        
        return error;
    }
}

function redirectToLogin() {
    const loginPath = "/login";

    sessionStorage.clear();
    location.href = loginPath;
}

function redirectToForbidden() {
    const forbiddenPath = "/forbidden";

    location.href = forbiddenPath;
}

export default request;